export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <div className="fixed inset-0 pointer-events-none opacity-30">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle, #a78bfa 2px, transparent 2px)`,
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <nav className="relative z-50 bg-white/80 backdrop-blur-md shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="text-3xl font-bold text-purple-600 cursor-pointer" style={{ fontFamily: '"Pacifico", serif' }}>
            VIM
          </a>
          <a
            href="/#contact"
            className="px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold rounded-full hover:shadow-lg hover:shadow-purple-300 transition-all whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
          </a>
        </div>
      </nav>

      <section className="relative py-24">
        <div className="absolute top-20 right-20 w-80 h-80 rounded-full bg-gradient-to-br from-purple-300/30 to-pink-300/30 blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-72 h-72 rounded-full bg-gradient-to-br from-blue-300/30 to-purple-300/30 blur-3xl"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10">
          <div className="bg-white/85 backdrop-blur-sm rounded-[3rem] p-12 border-4 border-purple-200 shadow-xl">
            <div className="text-center mb-12">
              <span className="text-purple-600 font-bold text-sm tracking-wider uppercase mb-4 block">Privacy Policy</span>
              <h1 className="text-4xl md:text-5xl font-black text-gray-800 mb-4">プライバシーポリシー</h1>
              <p className="text-gray-600 leading-relaxed">
                合同会社VIMは、お客様の個人情報を適切に取り扱い、安心してご相談いただける運営を行います。
              </p>
            </div>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <div className="rounded-[2rem] bg-purple-50/70 border border-purple-100 p-8">
                <h2 className="text-2xl font-black text-gray-800 mb-4">1. 取得する情報</h2>
                <p>
                  当社は、お問い合わせフォーム等を通じて、お名前、会社名、メールアドレス、電話番号、お問い合わせ内容等の情報を取得する場合があります。
                </p>
              </div>

              <div className="rounded-[2rem] bg-pink-50/70 border border-pink-100 p-8">
                <h2 className="text-2xl font-black text-gray-800 mb-4">2. 利用目的</h2>
                <p>
                  取得した個人情報は、お問い合わせへの回答、サービスのご案内、業務上必要なご連絡、サービス改善のための参考資料として利用します。
                </p>
              </div>

              <div className="rounded-[2rem] bg-blue-50/70 border border-blue-100 p-8">
                <h2 className="text-2xl font-black text-gray-800 mb-4">3. 第三者提供について</h2>
                <p>
                  当社は、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者へ提供することはありません。
                </p>
              </div>

              <div className="rounded-[2rem] bg-purple-50/70 border border-purple-100 p-8">
                <h2 className="text-2xl font-black text-gray-800 mb-4">4. 安全管理</h2>
                <p>
                  当社は、個人情報への不正アクセス、漏えい、滅失又はき損等を防止するため、必要かつ適切な安全管理措置を講じます。
                </p>
              </div>

              <div className="rounded-[2rem] bg-pink-50/70 border border-pink-100 p-8">
                <h2 className="text-2xl font-black text-gray-800 mb-4">5. 開示・訂正・削除等</h2>
                <p>
                  ご本人から、自己の個人情報について開示、訂正、利用停止、削除等のお申し出があった場合には、法令に従い適切に対応します。
                </p>
              </div>

              <div className="rounded-[2rem] bg-blue-50/70 border border-blue-100 p-8">
                <h2 className="text-2xl font-black text-gray-800 mb-4">6. お問い合わせ窓口</h2>
                <div className="space-y-2">
                  <p>合同会社VIM</p>
                  <p>東京都渋谷区本町三丁目5番2-501号</p>
                  <p>メールアドレス: account.v@vim-email.com</p>
                  <p>電話番号: 050-8895-4340</p>
                </div>
              </div>
            </div>

            <div className="mt-10 text-center">
              <a
                href="/"
                className="inline-flex items-center justify-center px-6 py-3 rounded-full border-2 border-purple-200 text-purple-700 font-bold hover:bg-purple-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                トップへ戻る
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
